"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreFactorCard = void 0;
const react_1 = __importDefault(require("react"));
const base_react_components_1 = require("@navinc/base-react-components");
const styled_components_1 = __importDefault(require("styled-components"));
const StyledStandardCard = (0, styled_components_1.default)(base_react_components_1.StandardCard).withConfig({ displayName: "reports-StyledStandardCard", componentId: "reports-q063l3" }) `
  display: grid;
  grid-gap: 16px;
`;
const StyledHeader = (0, styled_components_1.default)(base_react_components_1.Header).withConfig({ displayName: "reports-StyledHeader", componentId: "reports-crwuo" }) `
  display: grid;
  grid-template-columns: ${({ icon }) => (icon ? '1.5em 1fr' : '1fr')};
  & > :first-child {
    margin-right: 0.5em;
    color: ${base_react_components_1.theme.neutral400};
  }
`;
const StyledListItem = (0, styled_components_1.default)(base_react_components_1.ListItem).withConfig({ displayName: "reports-StyledListItem", componentId: "reports-1cngntu" }) `
  margin-bottom: 16px;
`;
const ListSection = styled_components_1.default.div.withConfig({ displayName: "reports-ListSection", componentId: "reports-42y93d" }) `
  & > :first-child {
    padding-left: 16px;
    margin: 0 0 16px 0;
  }
`;
/** The ScoreFactorCard component provides a list of factors that could be influencing the credit score */
const ScoreFactorCard = ({ factors = [], listType = 'ul', listItemSize = 'md', isListBold, isUpperCase, headerCopy, icon, testid, }) => {
    return (react_1.default.createElement(StyledStandardCard, { "data-testid": testid },
        react_1.default.createElement(StyledHeader, { icon: icon },
            icon && react_1.default.createElement(base_react_components_1.Icon, { name: icon }),
            headerCopy),
        react_1.default.createElement(base_react_components_1.Divider, null),
        react_1.default.createElement(ListSection, { "data-testid": `${testid}:list` },
            react_1.default.createElement(base_react_components_1.List, { element: listType }, factors.map((factor, i) => (react_1.default.createElement(StyledListItem, { bold: isListBold, size: listItemSize, key: i, "data-testid": `${testid}:list-item` }, isUpperCase ? factor.toUpperCase() : factor)))))));
};
exports.ScoreFactorCard = ScoreFactorCard;
exports.default = exports.ScoreFactorCard;
//# sourceMappingURL=index.js.map